import { call, put, takeLatest } from 'redux-saga/effects';
import systemLogService from '../../../services/systemLogService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchSystemLogs,
  fetchSystemLogsSuccess,
  fetchSystemLogsFailure,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(systemLogService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message));
  }
}

function* handleFetchSystemLogs(action) {
  try {
    const response = yield call(systemLogService.getSystemLogs, action.payload);
    yield put(fetchSystemLogsSuccess(response));
  } catch (error) {
    yield put(fetchSystemLogsFailure(error.message));
  }
}

export function* watchSystemLogsActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchSystemLogs.type, handleFetchSystemLogs);
}
